import axiosV2Instance from './axiosV2Instance';

export interface LedgerV2Item {
  id: number;
  siteExecutorId: number;
  siteId: number;
  movementType: string;
  referenceId: number;
  amount: number;
  balanceAfter: number;
  description: string;
  createdAt: string;
  createdBy?: number | null;
  executorDisplayName: string;
  createdByName?: string | null;
  /** Выплата: тип строки платежа (премия, зарплата, …) */
  paymentTypeCode?: string | null;
  paymentTypeName?: string | null;
  /** Начисление/коррекция: тип из Earnings (работа, премия, …) */
  earningTypeCode?: string | null;
  earningTypeName?: string | null;
  /** Документ платежа (Payments.Id) */
  paymentId?: number | null;
  /** Для документа платежа — не показывать «баланс после» как у проводки Ledger */
  showsBalanceAfter?: boolean;
}

export interface LedgerV2Query {
  startDate?: Date;
  endDate?: Date;
  siteExecutorId?: number;
  userId?: number;
  limit?: number;
}

/** Остаток к оплате по одному типу начисления (работа, премия, компенсация, …) */
export interface ExecutorBalanceByTypeV2Item {
  earningTypeId: number;
  earningTypeCode: string;
  earningTypeName: string;
  amount: number;
}

/** Агрегат по Ledger: текущий баланс исполнителя на объекте */
export interface ExecutorBalanceV2Item {
  siteExecutorId: number;
  balance: number;
  executorDisplayName: string;
  /** Разбивка «к оплате» по типам начислений (Earnings − распределения), ненулевые */
  unpaidByType?: ExecutorBalanceByTypeV2Item[];
  /** Выплачено, но не распределено по начислениям: SUM(unpaidByType) − balance */
  unallocatedPayments?: number;
}

export interface ExecutorBalancesV2Query {
  siteExecutorId?: number;
  userId?: number;
}

class LedgerV2Api {
  async getSiteLedger(siteId: number, query: LedgerV2Query = {}): Promise<LedgerV2Item[]> {
    const params = new URLSearchParams();
    if (query.startDate) params.append('startDate', query.startDate.toISOString());
    if (query.endDate) params.append('endDate', query.endDate.toISOString());
    if (query.siteExecutorId && query.siteExecutorId > 0) {
      params.append('siteExecutorId', String(query.siteExecutorId));
    }
    if (query.userId && query.userId > 0) {
      params.append('userId', String(query.userId));
    }
    if (query.limit != null && query.limit > 0) {
      params.append('limit', String(query.limit));
    }
    const qs = params.toString();
    const url = `/sites/${siteId}/ledger${qs ? `?${qs}` : ''}`;
    const response = await axiosV2Instance.get<LedgerV2Item[]>(url);
    return response.data;
  }

  async getSiteExecutorBalances(
    siteId: number,
    query: ExecutorBalancesV2Query = {}
  ): Promise<ExecutorBalanceV2Item[]> {
    const params = new URLSearchParams();
    if (query.siteExecutorId && query.siteExecutorId > 0) {
      params.append('siteExecutorId', String(query.siteExecutorId));
    }
    if (query.userId && query.userId > 0) {
      params.append('userId', String(query.userId));
    }
    const qs = params.toString();
    const url = `/sites/${siteId}/executor-balances${qs ? `?${qs}` : ''}`;
    const response = await axiosV2Instance.get<ExecutorBalanceV2Item[]>(url);
    return response.data;
  }
}

export const ledgerV2Api = new LedgerV2Api();
